var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSeodet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_877",
    "data-name": "Group 877",
    xmlns: "http://www.w3.org/2000/svg",
    width: 652.495,
    height: 603.569,
    viewBox: "0 0 652.495 603.569",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_707",
    "data-name": "Group 707",
    transform: "translate(45.934 41.974)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_24",
    "data-name": "Ellipse 24",
    cx: 280.328,
    cy: 257.361,
    rx: 280.328,
    ry: 257.361,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    strokeDasharray: "0.249 7.976"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_711",
    "data-name": "Group 711",
    transform: "translate(84.213 236.007)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_709",
    "data-name": "Group 709"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_708",
    "data-name": "Group 708"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1117",
    "data-name": "Path 1117",
    d: "M512.779,422.591a12.969,12.969,0,0,1-12.965,12.965H41.675A12.969,12.969,0,0,1,28.71,422.591V93.425A12.969,12.969,0,0,1,41.675,80.46h458.14a12.969,12.969,0,0,1,12.965,12.965Z",
    transform: "translate(-28.71 -80.46)",
    fill: "#140578"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_391",
    "data-name": "Rectangle 391",
    width: 462.305,
    height: 306.874,
    transform: "translate(10.882 20.533)",
    fill: "#e8e5ff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1118",
    "data-name": "Path 1118",
    d: "M178.387,199.016a3.217,3.217,0,0,1-3.226,3.227h-74.5a3.217,3.217,0,0,1-3.227-3.227h0a3.242,3.242,0,0,1,3.227-3.256h74.5a3.242,3.242,0,0,1,3.226,3.256Z",
    transform: "translate(104.141 142.44)",
    fill: "#f3a51c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1119",
    "data-name": "Path 1119",
    d: "M152.449,86.281a3.048,3.048,0,0,1-3.051,3.051H105.811a3.048,3.048,0,0,1-3.05-3.051h0a3.048,3.048,0,0,1,3.05-3.051H149.4a3.03,3.03,0,0,1,3.051,3.051Z",
    transform: "translate(114.445 -75.105)",
    fill: "#f3a51c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_710",
    "data-name": "Group 710",
    transform: "translate(10.882 20.533)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1120",
    "data-name": "Path 1120",
    d: "M442.556,87.46H386.473L57.16,394.333h62.067Z",
    transform: "translate(15.408 -87.46)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1121",
    "data-name": "Path 1121",
    d: "M411.128,87.46H334.806S32.713,358.665,32.42,358.665v35.668H76.066Z",
    transform: "translate(-32.42 -87.46)",
    fill: "#fff"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_716",
    "data-name": "Group 716",
    transform: "translate(61.48 60.894)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1122",
    "data-name": "Path 1122",
    d: "M148.966,84.763a64,64,0,1,1-64-64A64.006,64.006,0,0,1,148.966,84.763Z",
    transform: "translate(-20.96 -20.76)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_715",
    "data-name": "Group 715",
    transform: "translate(18.245 19.682)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_712",
    "data-name": "Group 712",
    transform: "translate(0 13.346)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_392",
    "data-name": "Rectangle 392",
    width: 10.824,
    height: 68.989,
    transform: "translate(72.744)",
    fill: "#140578"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_393",
    "data-name": "Rectangle 393",
    width: 10.824,
    height: 40.361,
    transform: "translate(18.186 28.628)",
    fill: "#f3a51c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_394",
    "data-name": "Rectangle 394",
    width: 10.824,
    height: 59.662,
    transform: "translate(54.558 9.328)",
    fill: "#f3a51c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_395",
    "data-name": "Rectangle 395",
    width: 10.824,
    height: 51.155,
    transform: "translate(36.372 17.834)",
    fill: "#9c2eff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_396",
    "data-name": "Rectangle 396",
    width: 10.824,
    height: 32.647,
    transform: "translate(0 36.343)",
    fill: "#9c2eff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_714",
    "data-name": "Group 714",
    transform: "translate(0.581)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_713",
    "data-name": "Group 713",
    transform: "translate(0 2.024)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1123",
    "data-name": "Path 1123",
    d: "M28.821,66.908a1.423,1.423,0,0,1-1.261-.763,1.441,1.441,0,0,1,.557-1.965L93.088,28.336a1.467,1.467,0,0,1,1.965.557,1.441,1.441,0,0,1-.557,1.965l-65,35.873A1.363,1.363,0,0,1,28.821,66.908Z",
    transform: "translate(-27.378 -28.16)",
    fill: "#140578"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1124",
    "data-name": "Path 1124",
    d: "M54.79,40.347l4.459-11.616L46.9,27.47Z",
    transform: "translate(10.362 -27.47)",
    fill: "#2d4199"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_718",
    "data-name": "Group 718",
    transform: "translate(0 221.722)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1125",
    "data-name": "Path 1125",
    d: "M130.411,140.8A65.205,65.205,0,1,1,65.205,75.59,65.2,65.2,0,0,1,130.411,140.8Z",
    transform: "translate(0 -75.59)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_717",
    "data-name": "Group 717",
    transform: "translate(19.125 24.756)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_397",
    "data-name": "Rectangle 397",
    width: 9.269,
    height: 26.458,
    transform: "translate(16.807 54.441)",
    fill: "#f3a51c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_398",
    "data-name": "Rectangle 398",
    width: 14.167,
    height: 8.389,
    transform: "translate(14.343 48.662)",
    fill: "#9c2eff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1126",
    "data-name": "Path 1126",
    d: "M32.59,89.73v32.412a16.214,16.214,0,0,0,0-32.412Z",
    transform: "translate(43.879 -73.011)",
    fill: "#140578"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1127",
    "data-name": "Path 1127",
    d: "M18.282,91.14v24.287a12.15,12.15,0,0,1,0-24.287Z",
    transform: "translate(-6.52 -70.285)",
    fill: "#140578"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1128",
    "data-name": "Path 1128",
    d: "M57.894,85.18C30.557,97.587,16.36,96.766,16.36,96.766v35.345s22.527-.528,41.534,11.821Z",
    transform: "translate(12.503 -81.807)",
    fill: "#9c2eff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_399",
    "data-name": "Rectangle 399",
    width: 24.844,
    height: 36.401,
    transform: "translate(7.157 14.578)",
    fill: "#140578"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_400",
    "data-name": "Rectangle 400",
    width: 11.557,
    height: 63.622,
    transform: "translate(68.139)",
    fill: "#f3a51c"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_721",
    "data-name": "Group 721",
    transform: "translate(522.084 231.988)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1129",
    "data-name": "Path 1129",
    d: "M308.4,144.3A65.205,65.205,0,1,1,243.2,79.09,65.2,65.2,0,0,1,308.4,144.3Z",
    transform: "translate(-177.99 -79.09)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_720",
    "data-name": "Group 720",
    transform: "translate(24.228 24.17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1130",
    "data-name": "Path 1130",
    d: "M220.219,128.336c0,.851-30.329-27.6-30.329-27.6a40.881,40.881,0,0,1,30.329-13.4Z",
    transform: "translate(-179.213 -87.33)",
    fill: "#f3a51c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1131",
    "data-name": "Path 1131",
    d: "M241.226,128.336H200.22V87.33A40.991,40.991,0,0,1,241.226,128.336Z",
    transform: "translate(-159.243 -87.33)",
    fill: "#9c2eff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1132",
    "data-name": "Path 1132",
    d: "M186.25,101.33h41.006v41.006A41.047,41.047,0,0,1,186.25,101.33Z",
    transform: "translate(-186.25 -60.265)",
    fill: "#9c2eff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1133",
    "data-name": "Path 1133",
    d: "M227.256,119.5H186.25a40.94,40.94,0,0,1,10.677-27.6Z",
    transform: "translate(-186.25 -78.495)",
    fill: "#140578"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_719",
    "data-name": "Group 719",
    transform: "translate(41.006 41.046)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1134",
    "data-name": "Path 1134",
    d: "M200.23,101.342c0-.851,30.329,27.6,30.329,27.6a40.882,40.882,0,0,1-30.329,13.4Z",
    transform: "translate(-200.23 -101.324)",
    fill: "#f3a51c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1135",
    "data-name": "Path 1135",
    d: "M200.23,101.33h41.006a40.939,40.939,0,0,1-10.677,27.6Z",
    transform: "translate(-200.23 -101.311)",
    fill: "#140578"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_723",
    "data-name": "Group 723",
    transform: "translate(243.868)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_722",
    "data-name": "Group 722"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1136",
    "data-name": "Path 1136",
    d: "M225.871,71.365A71.365,71.365,0,1,1,154.505,0,71.354,71.354,0,0,1,225.871,71.365Z",
    transform: "translate(-83.14)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1137",
    "data-name": "Path 1137",
    d: "M183.7,41.757H167.477l11.117-11.821-18.743-17.6-9.24,9.826V8.67H124.887V24.891L113.066,13.774l-17.6,18.743,9.826,9.24H91.8V67.481h16.221L96.9,79.3l18.743,17.6,9.24-9.826v13.493h25.724V84.347l11.821,11.117,17.6-18.743-9.826-9.24H183.7ZM137.764,73.113A18.509,18.509,0,1,1,156.272,54.6,18.508,18.508,0,0,1,137.764,73.113Z",
    transform: "translate(-66.398 16.761)",
    fill: "#140578"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_728",
    "data-name": "Group 728",
    transform: "translate(448.519 60.894)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_724",
    "data-name": "Group 724"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1138",
    "data-name": "Path 1138",
    d: "M280.945,84.763a64.018,64.018,0,1,1-64.032-64A64.012,64.012,0,0,1,280.945,84.763Z",
    transform: "translate(-152.91 -20.76)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_727",
    "data-name": "Group 727",
    transform: "translate(14.285 14.871)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_726",
    "data-name": "Group 726",
    transform: "translate(7.626 12.76)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_725",
    "data-name": "Group 725"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1139",
    "data-name": "Path 1139",
    d: "M218.194,104.185,160.38,67.08l57.814-36.9,3.549,5.544-49.19,31.385,49.19,31.561Z",
    transform: "translate(-160.38 -30.18)",
    fill: "#140578"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1140",
    "data-name": "Path 1140",
    d: "M175.85,40.056A14.226,14.226,0,1,0,190.076,25.83,14.221,14.221,0,0,0,175.85,40.056Z",
    transform: "translate(-122.847 -25.83)",
    fill: "#f3a51c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1141",
    "data-name": "Path 1141",
    d: "M157.78,53.311A16.631,16.631,0,1,0,174.411,36.68,16.637,16.637,0,0,0,157.78,53.311Z",
    transform: "translate(-157.78 -4.855)",
    fill: "#f3a51c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_25",
    "data-name": "Ellipse 25",
    cx: 14.226,
    cy: 14.226,
    r: 14.226,
    transform: "translate(53.003 69.781)",
    fill: "#f3a51c"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_732",
    "data-name": "Group 732",
    transform: "translate(146.866 329.195)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_729",
    "data-name": "Group 729",
    transform: "translate(211.72 6.336)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1142",
    "data-name": "Path 1142",
    d: "M247.709,147.57a54.892,54.892,0,0,1-2.083,5.69,60.813,60.813,0,0,1-13.141,19.359,61.85,61.85,0,0,1-19.271,12.935,59.212,59.212,0,0,1-46.345,0A61.849,61.849,0,0,1,147.6,172.62a53.384,53.384,0,0,1-4.224-4.723c-4.635,3.637-9.68,6.688-14.285,10.384-.293.235-.587.469-.88.733a73.579,73.579,0,0,0,5.749,6.365,78.493,78.493,0,0,0,25.2,16.543,80.65,80.65,0,0,0,86.97-16.543,77.072,77.072,0,0,0,16.954-24.991,68.51,68.51,0,0,0,2.7-7.451C259.765,151.061,253.84,148.919,247.709,147.57Z",
    transform: "translate(-110.728 -50.246)",
    fill: "#f3a51c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1143",
    "data-name": "Path 1143",
    d: "M242.741,162.641A81.821,81.821,0,0,0,225.7,137.562a79.586,79.586,0,0,0-25.2-16.954,78.945,78.945,0,0,0-61.422,0c-.147.059-.264.117-.411.176l7.421,15.869c6.57-2.435,16.074-4.634,23.671-4.634a59.856,59.856,0,0,1,43.529,18.157,58.864,58.864,0,0,1,12.437,19.477,63.569,63.569,0,0,1,4.4,23.583c0,5.544-2.024,15.341-3.344,20.386l18.039,5.544a79.763,79.763,0,0,0,4.165-25.9A73.464,73.464,0,0,0,242.741,162.641Z",
    transform: "translate(-90.507 -114.39)",
    fill: "#9c2eff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1144",
    "data-name": "Path 1144",
    d: "M142.43,242.556c4.84-3.96,9.826-7.773,14.93-11.381a61.257,61.257,0,0,1-11.381-17.541,60.473,60.473,0,0,1-4.81-24.17,63.569,63.569,0,0,1,4.4-23.583,58.651,58.651,0,0,1,31.591-32.705c.557-.264,1.144-.469,1.7-.7-2.493-5.28-4.723-10.677-6.864-16.133-.381.147-.792.293-1.173.469a79.912,79.912,0,0,0-25.2,16.954,81.309,81.309,0,0,0-17.042,25.079,74.9,74.9,0,0,0-6.336,30.594,77.963,77.963,0,0,0,20.18,53.121Z",
    transform: "translate(-122.25 -110.62)",
    fill: "#140578"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_730",
    "data-name": "Group 730",
    transform: "translate(117.71 6.57)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1145",
    "data-name": "Path 1145",
    d: "M109.061,151.09H90.2v43.881h81.25V177.724h-62.39Z",
    transform: "translate(-90.2 -43.675)",
    fill: "#f3a51c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1146",
    "data-name": "Path 1146",
    d: "M109.061,128.88H90.2v66.731h18.861V163.463h60.6V146.215h-60.6Z",
    transform: "translate(-90.2 -86.612)",
    fill: "#9c2eff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1147",
    "data-name": "Path 1147",
    d: "M90.2,114.47v43.881h18.861V131.717h62.39V114.47Z",
    transform: "translate(-90.2 -114.47)",
    fill: "#140578"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_731",
    "data-name": "Group 731"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1148",
    "data-name": "Path 1148",
    d: "M109.644,176.452c-.029,0-.029.029-.059.029a25.7,25.7,0,0,1-11.146,2.405A31.186,31.186,0,0,1,87,176.775a28.8,28.8,0,0,1-9.445-5.925,26.41,26.41,0,0,1-6.218-9.122,29.888,29.888,0,0,1-2.2-11.528L50.07,154.218a51.624,51.624,0,0,0,5.221,16.866,46.938,46.938,0,0,0,10.12,13.434A45.89,45.89,0,0,0,96.8,196.545a51.32,51.32,0,0,0,18.3-3.226C114.044,187.452,111.55,182.055,109.644,176.452Z",
    transform: "translate(-50.07 -38.826)",
    fill: "#f3a51c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1149",
    "data-name": "Path 1149",
    d: "M62.363,175.734a46,46,0,0,0,10.53,7.832q6.028,3.3,12.437,6.13l10.442,4.4c2.405,1,4.781,2.141,7.157,3.315,2.933-5.485,6.306-10.706,9.24-16.191-2.875-1.408-5.837-2.757-8.976-3.989L92.37,173.006a75.9,75.9,0,0,1-7.333-3.315,33.644,33.644,0,0,1-6.717-4.517,24.669,24.669,0,0,1-5.016-6.013,15.034,15.034,0,0,1-1.995-7.832,17.786,17.786,0,0,1,2.2-8.917,22.315,22.315,0,0,1,5.808-6.717,26.648,26.648,0,0,1,8.125-4.312,28.849,28.849,0,0,1,9.122-1.5q8.624,0,14.343,3.608a31.24,31.24,0,0,1,9.944,10.648l15.047-9.034A43.121,43.121,0,0,0,96.975,112.23a52.306,52.306,0,0,0-16.661,2.7,46.445,46.445,0,0,0-14.256,7.714,38.067,38.067,0,0,0-9.944,12.231A35.6,35.6,0,0,0,52.39,151.33a33.7,33.7,0,0,0,2.7,13.845A36.234,36.234,0,0,0,62.363,175.734Z",
    transform: "translate(-45.585 -112.23)",
    fill: "#140578"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1150",
    "data-name": "Path 1150",
    d: "M108.383,162.646a40.128,40.128,0,0,0-7.832-12.554,49.239,49.239,0,0,0-11.938-9.328,121.459,121.459,0,0,0-12.232-5.984c-3.021,5.4-6.1,10.794-8.712,16.367q4.092,1.76,8.1,3.872a42.781,42.781,0,0,1,8.418,5.808,25.146,25.146,0,0,1,5.925,7.832,23.785,23.785,0,0,1,2.2,10.53A30.238,30.238,0,0,1,90.2,190.511a29.807,29.807,0,0,1-5.808,9.328,28.524,28.524,0,0,1-8.829,6.424c-.411.205-.821.323-1.261.5a169.908,169.908,0,0,0,3.813,17.365c1.261-.381,2.523-.821,3.755-1.291A46.9,46.9,0,0,0,97.208,213.1a44.517,44.517,0,0,0,10.237-14.959,48.1,48.1,0,0,0,3.725-18.949A45.462,45.462,0,0,0,108.383,162.646Z",
    transform: "translate(-16.045 -68.636)",
    fill: "#9c2eff"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_733",
    "data-name": "Group 733",
    transform: "translate(375.834 353.424)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_401",
    "data-name": "Rectangle 401",
    width: 13.639,
    height: 42.385,
    transform: "translate(55.673 119.617)",
    fill: "#9c2eff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1151",
    "data-name": "Path 1151",
    d: "M254.434,183.642a63.152,63.152,0,1,1-63.152-63.152A63.155,63.155,0,0,1,254.434,183.642Z",
    transform: "translate(-128.13 -120.49)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1152",
    "data-name": "Path 1152",
    d: "M144.98,168.5v97.119a12.193,12.193,0,0,0,12.2,12.2h1.731a12.193,12.193,0,0,0,12.2-12.2V168.5Z",
    transform: "translate(-95.555 -27.676)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1153",
    "data-name": "Path 1153",
    d: "M231.319,174.459A49.219,49.219,0,1,1,182.1,125.24,49.21,49.21,0,0,1,231.319,174.459Z",
    transform: "translate(-118.947 -111.307)",
    fill: "#140578"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeodet);
export default __webpack_public_path__ + "static/media/seodet.722927117b6dfd7fd5cc20346649a1d7.svg";
export { ForwardRef as ReactComponent };